import React, {useEffect} from "react";

import 'bootstrap/dist/js/bootstrap.bundle.min';
import './App.scss';

/* Page components */
import Header from './components/Header';
import MainInfo from "./components/MainInfo";
import Sponsors from "./components/Sponsors";
import {TimeTable} from "./components/Timetable";

function App() {

    useEffect(() => {
        /* Change page title here */
        document.title = "4. interdisziplinären Fachkongress mit augenärztlicher Weiterbildung";
    }, []);

  return (
      <React.Fragment>
          <Header />
          <MainInfo />
          <TimeTable />
          <Sponsors />
      </React.Fragment>
  );
}

export default App;
